export default {
  getAll(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/modules/lessons/u/list/${id}?status=published`)
        .then(response => {
          context.commit("setLessons", response.data);
          resolve();
        })
        .catch(reject);
    });
  },
  search(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId || 171;
      window.axios
        .get(`/modules/lessons/${productId}?${queryString}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getFavorites(context, params) {
    return new Promise((resolve, reject) => {
      const query_params = new URLSearchParams(params).toString();
      window.axios
        .get(`/modules/lessons/favorites?${query_params}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  addFavorite(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`/modules/lessons/favorites`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  removeFavorite(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/modules/lessons/favorites/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  postRating(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`/modules/lessons/rating`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  putRating(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/modules/lessons/rating/${data.id}`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  getRating(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/modules/lessons/rating/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  getNotations(context, lesson_id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/modules/lessons/${lesson_id}/notes`)
        .then(response => resolve(response.data))
        .catch(reject);
    });
  },
  postNotations(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`/modules/lessons/${data.lesson}/notes`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  putNotations(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/modules/lessons/notes/${data.id}`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  deleteNotations(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/modules/lessons/notes/${id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
